import React from "react";

const SvgMedWine = props => (
  <svg viewBox="0 0 215 215" {...props}>
    <path
      d="M135.6 37.3l-1.4-3.7H81.4L80 37.3c-6.1 17.2-14.3 47-6.2 67.2 1 2.4 2.2 4.7 3.7 6.9 3.9 5.6 10.3 9.4 17.6 11.5 3 .9 6.1 1.5 9.2 1.7v49.3H82.4v7.1h51.9v-7.1h-22.6v-49.3c2.9-.3 5.8-.9 8.6-1.7 7.4-2.1 13.8-6 17.7-11.5 1.7-2.5 3.1-5.2 4.2-8.1 7.3-20.2-.6-49.2-6.6-66zM76.1 89.2c-.7-9.9 1-20.9 3.2-30.5.3-1.8.8-3.7 1.4-5.5 1.6-5.8 3.2-10.5 4.5-14.1h45.1c1.3 3.5 2.9 8.6 4.4 14.1.9 2.6 1.5 5.5 1.5 5.5 2.3 9.5 4 20.5 3.3 30.5H76.1z"
      fill="currentColor"
    />
  </svg>
);

export default SvgMedWine;